// src/pages/Contact.js
import React, { useState } from "react";
import { Container, TextField, Button, Typography, Box } from "@mui/material";
import {  collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";


// Initialize Firebase


function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    try {
      // Save to Firestore
      await addDoc(collection(db, "leads"), formData);

      setStatus("✅ Your message has been submitted!");
      setFormData({ name: "", email: "", message: "" }); // clear form
    } catch (error) {
      console.error("Error adding document: ", error);
      setStatus("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Contact Us
      </Typography>
      <Typography variant="body1" align="center" sx={{ mb: 4 }}>
        Let’s build something amazing together.
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 600,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <TextField
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          required
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          required
        />
        <TextField
          label="Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          variant="outlined"
          multiline
          rows={4}
          fullWidth
          required
        />
        <Button type="submit" variant="contained" color="success" size="large">
          Send Message
        </Button>
        {status && (
          <Typography align="center" sx={{ mt: 2 }}>
            {status}
          </Typography>
        )}
      </Box>
    </Container>
  );
}

export default Contact;
